import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../../services/store.service';
import { ApiService } from './../../../../services/api.service';
import { Profil } from './../../../../models/Profil';
import { CommandeService } from './../../../../services/commande.service';
import { SelectItem, Message, ConfirmationService, UIChart } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ExcelService } from 'src/app/services/Excel.service';

@Component({
  selector: 'app-cellout',
  templateUrl: './cellout.component.html',
  styleUrls: ['./cellout.component.css']
})
export class CelloutComponent implements OnInit {

  titre = 'Marge arrière - SELL OUT';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  selectedPdg: string;
  selectedMsisdn: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  items: any[] = [];

  selectedAnnee: any ;
  selectedMois: any ;
  listAnnee: SelectItem[] = [];
  listMois: SelectItem[] = [];
  displaychargement:boolean;

  margeArriereTelco:number;
  margeAvantTelco:number;
  commissionCashin:number;
  commissionCashout:number;
  montantCommande:number;
  montantVente:number;
  totalCommissionOmy:number;
  totalCommissionTelco:number;
  montantOmy:number;

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private localiteService: LocaliteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    this.loadSelectList();
    this.initChartBarre();
    this.initChartPie();
  }


  async recherche() {
    if(this.selectedMsisdn === null || this.selectedMsisdn === undefined || this.selectedMsisdn === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un msisdn PDG ' });
      //return;
    }

    if(this.selectedAnnee === null || this.selectedAnnee === undefined || this.selectedAnnee === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection une année' });
      return;
    }
    if(this.selectedMois === null || this.selectedMois === undefined || this.selectedMois === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un mois ' });
      return;
    }

    let criteria: CriteriaData = new CriteriaData();
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.datedebut = "01/"+this.selectedMois+"/"+this.selectedAnnee ; //this.localeDateString(this.datedebut);
    criteria.datefin = "31/"+this.selectedMois+"/"+this.selectedAnnee ; //this.localeDateString(this.datefin);
    criteria.annee = this.selectedAnnee;
    criteria.mois = this.selectedMois;
    console.log(JSON.stringify(criteria));

    this.displaychargement=true;
    try {
      this.items = <any>await this.reportingVenteService.commissions(criteria).toPromise();
    } catch (error) {}
    
    console.log('items======'+ JSON.stringify(this.items));
    this.displaychargement=false;

    ////// FAIRE LES TOTAUX ET CHART /////
    this.margeArriereTelco=0;
    this.margeAvantTelco=0;
    this.commissionCashin=0;
    this.commissionCashout=0;
    this.montantCommande=0;
    this.montantVente=0;
    this.totalCommissionOmy=0;
    this.totalCommissionTelco=0;
    this.montantOmy=0;

    /*

      ca
      montant_commande

      objectif_vente_nafama
      objectif_commande_nafama
      
      ca_nafama
      montant_commande_nafama
      marge_avant_nafama
      commission_sell_in_nafama
      commission_sell_out_nafama

      ca_cag
      montant_commande_cag
      marge_avant_cag
      commission_sell_in_cag
      commission_sell_out_cag
      
      cashout_transaction_amount
      cashout_commission_pdg
      cashout_nb_transaction
      
      cashin_transaction_amount
      cashin_commission_pdg
      cashin_nb_transaction

    */
    this.items.forEach(e => {
      this.montantCommande += Number(e.montant_commande_nafama) + Number(e.montant_commande_cag);
      this.montantVente += Number(e.ca_nafama) + Number(e.ca_cag);
      this.margeAvantTelco += Number(e.marge_avant_cag) + Number(e.marge_avant_nafama)  ;
      this.margeArriereTelco += Number(e.commission_sell_in_cag) + Number(e.commission_sell_out_cag) + Number(e.commission_sell_in_nafama) + Number(e.commission_sell_out_nafama) ;
      this.commissionCashout += Number(e.cashout_transaction_amount);
      this.commissionCashin += Number(e.cashin_transaction_amount);
    });
    this.totalCommissionTelco = this.margeAvantTelco + this.margeArriereTelco;
    this.totalCommissionOmy = this.commissionCashout + this.commissionCashin;
    
    
    //this.printChartDonut(chartDonut);
    //this.printChartPie(chartPie);
  }

  async loadSelectList() {

    if(this.store.isUserPartenaire) {
      this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
      this.selectedPdg = this.store.currentNomPDG;
    } else {
      this.listLogin.push({ label: 'PDG...', value: null });
      try {
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listLogin.push({ label: el.login, value: el.login });
        }
      } catch (error) { }
    }

    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });

    this.listMois = [];
    //this.listMois.push({ label: 'Mois...', value: null });
    this.listMois.push({ label: 'Janvier', value: "01" });
    this.listMois.push({ label: 'Février', value: "02" });
    this.listMois.push({ label: 'Mars', value: "03" });
    this.listMois.push({ label: 'Avril', value: "04" });
    this.listMois.push({ label: 'Mai', value: "05" });
    this.listMois.push({ label: 'Juin', value: "06" });
    this.listMois.push({ label: 'Juillet', value: "07" });
    this.listMois.push({ label: 'Aout', value: "08" });
    this.listMois.push({ label: 'Septembre', value: "09" });
    this.listMois.push({ label: 'Octobre', value: "10" });
    this.listMois.push({ label: 'Novembre', value: "11" });
    this.listMois.push({ label: 'Decembre', value: "12" });
    this.listAnnee = [];
    //this.listAnnee.push({ label: 'Année...', value: null });
    this.listAnnee.push({ label: '2020', value: "2020" });
    this.listAnnee.push({ label: '2021', value: "2021" });
    this.listAnnee.push({ label: '2022', value: "2022" });
    this.listAnnee.push({ label: '2023', value: "2023" });
    this.listAnnee.push({ label: '2024', value: "2024" });
    this.listAnnee.push({ label: '2025', value: "2025" });
    
    let mydate = new Date();
    this.selectedAnnee = mydate.getFullYear() ;
    let mmois = mydate.getMonth() + 1;
    this.selectedMois =  (mmois > 9) ? mmois : "0"+mmois ; 
    console.log("this.selectedAnnee===="+this.selectedAnnee); 
    console.log("this.selectedMois===="+this.selectedMois);   

  }

  async onChangePDG(event) {
    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });
    let dataRet = <any>await this.clientsService.findByLogin(event).toPromise();
    for (let el of dataRet) {
      this.listMsisdn.push({ label: el.telephone, value: el.telephone });
    }
  }


  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }


  initChartBarre() {
    this.dataBar = {
      labels: ['Sabalibougou', 'Kalaban coro', 'Maganbougou', 'Hamdalaye', 'Bamako coura', 'ACI200', 'Kalaban coura', 'Sebenicore', 'Sabalibougou', 'Hamdalaye', 'Faladie', 'Sebenicore'],
      datasets: [
          {
              label: 'Vente Zone',
              backgroundColor: '#ff7e33',
              borderColor: '#ff7e33',
              data: [650000, 590000, 800000, 810000, 560000, 550000, 280000, 480000, 400000, 190000, 860000, 270000]
          },
          {
            label: 'Vente Hors Zone',
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            data: [600000, 630000, 700000, 800000, 460000, 450000, 380000, 580000, 300000, 300000, 960000, 200000]
        }
      ]
    };

  }

  initChartPie() {
      this.dataPie = {
        labels: ['ZONE','HORS_ZONE'],
        datasets: [
            {
                data: [500000, 300000],
                backgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ],
                hoverBackgroundColor: [
                    "#00A056",
                    "#FFCE56"
                ]
            }]
        };
    }

    async exporter() {
      if(this.items === null || this.items === undefined) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      if(this.items.length <= 0) {
        this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
        return;
      }
      let listExportXLSX = [];
      listExportXLSX = [...this.items.map(entry => ({
          "PDG": entry.pdg,
          "OBJECTIFS Sell Out FCFA TTC": entry.objectif_vente_nafama,
          "Sell_OUT CAG FCFA TTC": entry.ca_cag,
          "Sell_OUT Nafama FCFA TTC": entry.ca_nafama,
          "Reel Cumul Sell_OUT FCFA TTC": entry.ca_cag + entry.ca_nafama,
          "Taux Realisation (%)": ((entry.ca_cag + entry.ca_nafama) * 100 / entry.objectif_vente_nafama).toFixed(2),
          "Marge Arrière Objectif": (entry.taux_commission_sell_out_base).toFixed(2),
          "Marge Garantie": '1',
          "Total Marge Arrière": (1 + (entry.taux_commission_sell_out_base )).toFixed(2),
          "Montant Total Marges Arr Nafama + CAG FCFA TTC": entry.commission_sell_out_nafama + entry.commission_sell_out_cag 
        }))
      ];
      this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
      this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.items.length + ' Ligne(s) trouvée(s)' });
    }

}
